import {
    AD_UNIT,
    AVG_CPM,
    AVG_RPM, BID_RATE,
    GEO, GROSS_REVENUE, INITIAL_IMPRESSIONS,
    PAGE_VIEWS,
    PRODUCT_TYPE, REFRESH_IMPRESSIONS,
    TOTAL_IMPRESSIONS, VIEWABILITY, WIN_RATE,
    INTEGRATION, BID_REQUEST, BID_RESPONSE,
    WINNING_BID, GROSS_REVENUE_WITHOUT_DISCREPANCY,
    REVENUE_TYPE, AD_REQUEST, VIDEO_VIEWED, VIDEO_START,
    VIDEO_Q1, VIDEO_Q2, VIDEO_Q3, VIDEO_COMPLETE, VIDEO_CLICK, SITE
} from "../../../monetization/consts";

export const REPORT_TYPE = 'Monetization';

// general
export const ACCOUNT_UUID = 'accountUUID';
export const REPORT_UUID = 'reportUUID';
export const NEW_REPORT_UUID = 'newReport'
export const REPORT_NAME = 'name';
export const REPORT_NAME_LENGTH = '191';
export const REPORT_CREATED = 'createdAt';
export const REPORT_RANGE = 'dateRange';
export const REPORT_FROM = 'from';
export const REPORT_TO = 'to';
export const FILTERS = 'filters';
export const PERIOD_AGG = 'periodAggregationType';

// dimensions
export const DIMENSIONS = 'dimensions';
export const METRICS = 'metrics';
export const STANDARD_DIMENSION = 'standardDimension';
export const INTERVAL_DIMENSION = 'intervalDimension';
export const DIMENSION_TYPES = [STANDARD_DIMENSION , INTERVAL_DIMENSION];

export const PREBID_METRICS = 'prebidMetrics';
export const INTERNAL_DIMENSIONS = 'internalDimensions';
export const INTERNAL_METRICS = 'internalMetrics';
export const MONETIZATION_METRICS = 'monetizationMetrics';
export const PREBID_VIDEO_METRICS = 'prebidVideoMetrics';
export const PREBID_MONETIZATION_METRICS = 'prebidMonetizationMetrics';
export const PERFORMANCE_METRICS = 'performanceMetrics';
export const METRICS_TYPES = [MONETIZATION_METRICS,PREBID_MONETIZATION_METRICS,PREBID_VIDEO_METRICS,PERFORMANCE_METRICS];

// filters
export const SITES = 'SITE';
export const DEVICES = 'DEVICE';
export const COUNTRIES = 'GEO';

// schedule
// schedule
export const IS_SCHEDULED = 'isScheduled';
export const SCHEDULE = 'schedule';
export const START_DATE = 'startDate';
export const END_DATE = 'endDate';
export const FREQUENCY = 'frequency';
export const FORMAT = 'format';
export const RECIPIENTS = 'recipientEmails';
export const FREQUENCY_MESSAGE_MONTHLY = `Monthly reports will be sent on the first day of the month, and set the period to “last month” by default.`
// To be used for something like: Report will be sent every [Saturday] at 5:30pm EST till [2022-08-29].
export const FREQUENCY_MESSAGE_WEEKLY = [`Report will be sent every`, `at 5:30pm EST till`]
// To be used for something like: Report will be sent daily at 5:30pm EST till [2022-08-29].
export const FREQUENCY_MESSAGE_DAILY = `Report will be sent daily at 5:30pm EST till`

// SortableList groupings
// period aggregation
export const DATE = 'DATE'  // dimensions
export const YEAR = 'YEAR'  // dimensions
export const MONTH = 'MONTH'  // dimensions
export const WEEK = 'WEEK'  // dimensions
export const QUARTER = 'QUARTER'  // dimensions

export const NET_REVENUE = 'NET_REVENUE'  // metrics

// table
export const NOT_AVAILABLE = 'N/A'

// form columns
export const FORM_HEADERS = [
    {key: "name", title: "Name"},
    {key: "frequency", title: "Delivery Schedule"},
    {key: "endDate", title: "End Date"},
    {key: "recipients", title: "Recipients"},
    {key: "creationDate", title: "Creation Date"},
    {key: "actions", title: ""},
];

// available date range shortcuts: YESTERDAY, LAST_SEVEN_DAYS, LAST_THIRTY_DAYS, LAST_WEEK, LAST_MONTH, CUSTOM
// form initial values, used for create new
export const DEFAULT_FORM_VALUES = {
    isOpened: true,
    reportUUID: 'newReport',
    accountUUID: null,
    createdAt: Date.now(),
    name: null,
    dateRange: "CUSTOM",
    from: null,
    to: null,
    dimensions: [DATE],
    metrics: [NET_REVENUE],
    standardDimension:[],
    intervalDimension:[DATE],
    prebidMonetizationMetrics: [],
    monetizationMetrics: [NET_REVENUE],
    performanceMetrics: [],
    prebidVideoMetrics: [],
    filters: {},
    //"schedule":{ "frequency":"ONCE", "format":"CSV" } === disabled
    isScheduled: false,
    schedule: {
        startDate: null,
        endDate: null,
        frequency: "ONCE",
        format: "CSV",
        recipientEmails: []
    }
}

export const DEFAULT_DIMENSION_STATE = {
    dimensions: [DATE],
    standardDimension:[],
    intervalDimension:[DATE],
}

export const DEFAULT_METRIC_STATE = {
    metrics: [NET_REVENUE],
    prebidMonetizationMetrics: [],
    monetizationMetrics: [NET_REVENUE],
    performanceMetrics: [],
    prebidVideoMetrics: [],
}

export const DEFAULT_SCHEDULE = {
    startDate: null,
    endDate: null,
    frequency: "ONCE",
    format: "CSV",
    recipientEmails: []
}

// period agg
export const PERIOD_AGG_OPTIONS = [
    {"name": "Daily", "value": "DAILY"},
    {"name": "Weekly", "value": "WEEKLY"},
    {"name": "Monthly", "value": "MONTHLY"},
    {"name": "Quarterly", "value": "QUARTERLY"},
]


// sortable list
// dimentions
export const DIMENSIONS_OPTIONS = [
    {value: YEAR, text: 'Year',type:INTERVAL_DIMENSION,isInternal:false},
    {value: QUARTER, text: 'Quarter',type:INTERVAL_DIMENSION,isInternal:false},
    {value: MONTH, text: 'Month',type:INTERVAL_DIMENSION,isInternal:false},
    {value: WEEK, text: 'Week',type:INTERVAL_DIMENSION,isInternal:false},
    {value: DATE, text: 'Day', type:INTERVAL_DIMENSION,isInternal:false},
    {value: PRODUCT_TYPE, text: 'Product', type:STANDARD_DIMENSION,isInternal:false},
    {value: SITE, text: 'Domain/App', type:STANDARD_DIMENSION,isInternal:false},
    {value: DEVICES, text: 'Device',type:STANDARD_DIMENSION,isInternal:false},
    {value: GEO, text: 'Country',type:STANDARD_DIMENSION,isInternal:false},
    {value: AD_UNIT, text: 'Ad Unit',type:STANDARD_DIMENSION,isInternal:false},
    {value: REVENUE_TYPE, text: 'Revenue Type',type:STANDARD_DIMENSION,isInternal:false},
    {value: INTEGRATION, text: 'Integration',type:STANDARD_DIMENSION, isInternal:true}

];

export const NO_PAGEVIEW_DIMENSION_SUPPORT = [PRODUCT_TYPE, AD_UNIT, REVENUE_TYPE, INTEGRATION]

export const DISABLE_DIMENSION_AND_METRIC_SUPPORT = [PRODUCT_TYPE]

// monetization metrics
// available: GROSS_REVENUE, AVG_RPM, AVG_CPM, AVG_AD_VIEWABILITY, NET_REVENUE, PAGE_VIEWS, INITIAL_IMPRESSIONS, REFRESH_IMPRESSIONS, IMPRESSIONS
export const METRICS_OPTIONS = [
    {value: NET_REVENUE, text: 'Publisher Revenue'},
    {value: AVG_RPM, text: 'Avg Page RPM'},
    {value: PAGE_VIEWS, text: 'Monetizable Page Views'},
    {value: VIEWABILITY, text: 'Avg Ad Viewabilty'}
];

// internal only metrics


export const PREBID_METRICS_OPTIONS = [
    {value: BID_RATE, text: 'Bid Rate'},
    {value: WIN_RATE, text: 'Win Rate'},

];

export const NO_PAGEVIEW_METRIC_SUPPORT = [AVG_RPM, PAGE_VIEWS]

export const PRODUCT_METRIC_SUPPORT = [BID_RATE, WIN_RATE, BID_REQUEST, BID_RESPONSE, INTEGRATION, WINNING_BID, GROSS_REVENUE_WITHOUT_DISCREPANCY,
    VIDEO_VIEWED, VIDEO_START, VIDEO_Q1, VIDEO_Q2, VIDEO_Q3, VIDEO_COMPLETE, VIDEO_CLICK]

// internal only dimensions
export const INTERNAL_DIMENSIONS_OPTIONS = [
    {value: INTEGRATION, text: 'Integration'}
];

// internal only metrics
export const INTERNAL_METRICS_OPTIONS = [
    {value: GROSS_REVENUE, text: 'Gross revenue'},
    {value: INITIAL_IMPRESSIONS, text: 'Initial loads'},
    {value: REFRESH_IMPRESSIONS, text: 'Refresh'},
    {value: AVG_CPM, text: 'Avg CPM'},
    {value: TOTAL_IMPRESSIONS, text: 'Impressions'},
    {value: WINNING_BID, text: 'Winning Bid'},
    {value: GROSS_REVENUE_WITHOUT_DISCREPANCY, text: 'Gross Revenue w/o Discrepancy'},
    {value: BID_REQUEST, text: 'Bid Request'},
    {value: BID_RESPONSE, text: 'Bid Response'},
    {value: AD_REQUEST, text: 'Ad Request'},
    {value: VIDEO_VIEWED, text: 'Video Viewed'},
    {value: VIDEO_START, text: 'Video Start'},
    {value: VIDEO_Q1, text: 'Video Q1'},
    {value: VIDEO_Q2, text: 'Video Q2'},
    {value: VIDEO_Q3, text: 'Video Q3'},
    {value: VIDEO_COMPLETE, text: 'Video Complete'},
    {value: VIDEO_CLICK, text: 'Video Click'}
];

// delivery settings
// available: WEEKLY, MONTHLY, ONCE, DAILY
export const FREQUENCY_OPTIONS = [
    {value: 'DAILY', title: 'Daily'},
    {value: 'WEEKLY', title: 'Weekly'},
    {value: 'MONTHLY', title: 'Monthly'}
];

export const FORMAT_OPTIONS = [
    {value: 'CSV', title: 'CSV'},
    {value: 'XLSX', title: 'Excel'}
];

// SSP accounts that use Druid MSQ for report generation (CSV only, XLSX not supported)
export const SSP_ACCOUNT_UUIDS = new Set([
    'f37c1a05-256f-4d34-a27f-7c8822716631',
    '43219255-112b-4498-9611-d971f8327962',
    'f466dda6-51fa-4d9d-b3e8-0dbc76e8ac97',
    '54cd3cd8-a633-45c0-a4b5-e794bd0d5622',
    'e0247337-444d-44f9-8a10-45f38333b383',
    'e053c774-c354-4e23-a1cb-006364e35bfd',
    '1c472931-6597-4f1f-b9ad-bf6db4b6b5e6',
    '3d7d65a4-e4d1-4c9d-ae32-77f4252b25eb',
    '5954e780-3109-4f11-9903-d80b3ec9068f',
    'ea7873c5-662b-4e03-a3f3-cec1a01d8a95',
    'f2ff22ea-9f29-4053-974c-2cda89954d3f',
    'b12bf1be-0b17-4562-a8de-2c3b8a7f310f',
    'cede319a-d5db-47d8-80ec-2fa53d6a8a2b',
    'a16e3531-e5cf-4167-bc0e-cba6c6a7aca3',
    '23914a4e-7621-4061-9cba-84b23ec846a3',
    'fc4f53e0-d1cb-4297-98f7-07dac1cd9120',
    'a4be8543-c8b1-4f3a-a4c0-73cfbdc3b652',
    '1c41044a-fdc4-4b71-8f0d-a5c4cd02ef14',
    '5062ba28-80ed-416e-86c0-5c05b7dbd10a',
    '8d3f8639-ee74-4300-8409-7950040c23bd',
    'b11bdaab-c372-43d7-9dc2-d783944ecf77',
    '57c63d8c-4e05-478d-8964-f7e2e632bdd8',
    'e557d856-e77c-4f28-9fb1-0df432980618',
    'f9b34633-afdc-49d6-aeb1-d4b3e3b921b2',
    '782c0dc9-ec8f-4562-8dd6-5385aba4922a',
    'f9a9979f-b478-4784-95b4-89f27c4e1db5',
    '9dc0dcd3-c2e6-43f3-a7e7-61eed661006c',
    'f2509bcc-8bae-4702-8893-81a3276d3195',
    '0ef2eb4c-75f2-4cdf-9185-b61dbd344670',
    '695fa4f1-47a6-4fb5-868b-5c057c1698a5',
    'bcef2f7a-0fb4-4c0a-96bf-49c0026da7a1',
    '11dab619-4d63-4578-b37d-b37992d12747',
    'af7e652f-1471-4988-ba00-720dd8d00039',
    '42f5d0d3-5cd9-4738-ba62-b3ac27c07770',
    '4cde3e6b-3048-4cb8-abf2-5d8606f7efb9',
    'd123e50a-dabb-473d-af58-35b59980eb9a',
    '9be2403e-f58b-4c92-8499-2aaa9cfa1c7d',
    '99deca53-34e8-41af-96df-28fbb358abec',
    '78b9b555-2bc7-4689-8b0f-72a686a67e52',
    'd7eb1fc0-b28d-48a1-b4a4-dd5709586411',
    'ef2f80d4-21b3-45c8-b372-d9471ea4678d',
    '36e14e4c-ea15-480c-bb20-5725ed6008af',
    'cedf79fb-105d-4149-8838-99e4743af34a',
    '9b3fe50d-a906-4b8c-8e69-8f7f43a82e01',
    'e08535d8-9376-417c-b1ac-56d5b552c4e4',
    '89ee84c0-8771-4a88-9b58-91898209f8db',
    '56049ab4-ce81-46d6-bb90-8d63841c197f',
    '496b147f-2547-4d59-8b1f-ec926ef05ed9',
    '59a4899c-f22d-4eff-9862-d0056f2d5c16',
    'd13a9b3d-7567-41ef-976a-2374d2ad3f66',
    'fdfd4ae3-fb6f-466a-8048-642db38f83dd',
    'c8437cf7-5eea-4a92-8d0c-5fba2c6374ec',
    'c1840875-27b6-4d28-8fde-51d55a142577',
    '81fbf791-6767-460d-9c2c-791b77ddeecd',
    'c1f8fad2-043c-4bed-a0ee-8e3461504f9a',
    '6fd3597f-61f4-4da4-a33c-adb2a3689455',
    'be9f3fb2-3a4a-468e-9dd8-1e941423d85b',
    'da08d3a2-f0d1-4cbd-a00a-4a5fe6d49d3f',
    'ce637c43-22f3-419d-b04d-324f5976e66b',
    '12f5dd4d-6c1e-46c8-a5e0-2596cce735c5',
    '157c07bd-dc2b-489c-bb54-795c37d58d2d',
    'a7273f2e-135d-45f5-9f9b-32811aed8628',
    '4bb549a6-034f-450c-988c-2458f94173ed',
    '531b47a5-dd13-490c-9257-918cc57ceced',
    '0bdc16f3-2724-4173-b5f9-04a42185f629',
    '8f4e5036-8601-467c-92b8-1a9bb7325f03',
    'c6f242d1-a3a9-42a4-8ffd-4502bed3fec0',
    '7c840ff0-bcfb-402f-aa9d-ab482c78f329',
    'b6eecbcb-a122-4c7e-9b77-6c6ed83d841c',
    '5e884aa5-bfb2-4ebf-b3bb-32fb237e0157',
    '15913fc3-5fec-4643-b761-8cb91495e66e',
    '795699cc-fa94-4495-89e4-99ed94637ba0',
    'e47bec7d-36ca-4422-a588-d377f4fe6512',
    'dbd44568-eb85-4001-9acd-aea8ea939922',
    '18ec4009-ac81-4a07-935f-5f33a7a2aab9',
    'b90e28c5-2156-4418-a99b-476f038964a6',
    'e460e64e-4db2-4dd6-8cfb-54360160aca5',
    '0461fbbc-2797-4bc5-8085-7def028e93b0',
    'a66ba99b-5b77-4264-8676-228c40a5984f',
    '5c317862-a09c-4129-9969-c07d71fd0d86',
    '601d8ea2-2a5d-4e88-9cd5-1563e66b16c8',
    '16a081e1-eafa-488e-ad98-a1a3c2364c03',
    'cecd7eed-9e24-42fd-bb7f-4b48a16005c1',
    '63e9a4ec-ed71-4945-8e81-b00fe09074d9',
    '4c5e3efc-8380-4861-9434-2905e1f678d6',
    'a6df4602-9b73-4107-b9e4-25483965d353',
    'bd45a367-d5fa-4207-9aec-1acba8ec52eb',
    '505a8579-bb95-41b2-bb72-d273ef7e08d4',
    '843c9a44-60ea-4342-8ad4-68f894283b3e',
    '06803a17-e13f-4506-ab6a-90954c80f227',
    '39930381-15b5-45ae-9ce5-d27d7baf4c01',
    'e9edea02-bf75-4d0d-9576-99abffce61ec',
    '6f3454d6-a337-4554-866d-0c73481afb78',
    '73dd4dc1-989d-4a4c-ae33-0b3d826dbc53',
    '11433359-ac39-41bc-9787-f21a2542cff5',
    'abd27653-d3a6-401c-a93f-2203b0889a6f',
    '17dfd405-e7d7-4498-8e29-376f0bbdf023',
    'a78e40a6-21d9-4d7a-92b6-6cf278e55862',
    'd25e0349-be51-4ba8-ab1d-ac7df7e1e59d',
    '33982127-4b91-4d23-9273-e18b7738b70f',
    '2bfd2f41-7136-4a33-b45b-84c723abc06b',
    'fa92b566-39b9-4651-b8c4-d57331b57247',
    '5bad937f-2915-4c41-a8c9-e27ff9f4b904',
    '62f38906-7683-4e37-beca-4587eed3451d',
    '56e938bd-7761-4b5c-8f5c-bb750417376c',
    '92943513-6f16-449c-b712-951de51804d3',
    'a27ed8b1-1214-4fac-bf09-20c1d1073143',
    'e8c90f14-b8e3-4251-ac5e-0dfb812ad734',
    'c70bc914-6db1-4157-ad18-613e87d46cd2',
    'da902dc1-b413-4f1e-856e-52cb2c43fab2',
    '1ac9862d-4975-49b3-9493-ea076a93c31f',
    '41f51e3a-c1fb-4bfc-bdcb-e4b8767d8117',
    '6391084d-b7b6-4237-ae01-317d3a1022a7',
    'ed7e4e82-5151-4787-8952-9d19fadf6b1c',
    'a68f9e3a-d501-43bb-9543-30df9cf10924',
    'a3c8e300-1d65-419e-af47-1c3afdb522d7',
    'de2606e8-347e-4b77-9fdb-cc233b0df34a',
]);

// error texts
export const RECIPIENTS_ERROR_TEXT = 'Please select at least one recipient';
export const TOO_MANY_RECIPIENTS_ERROR_TEXT = 'Recipients limit is 10';
export const EMAIL_ERROR_TEXT = 'Wrong email format, please enter valid email address';
export const EMAIL_DUPLICATED_ERROR_TEXT = 'Email already included in the list';
export const REPORT_NAME_ERROR_TEXT = 'Report name is required';
export const REPORT_NAME_DUPLICATED_ERROR_TEXT = 'Report name already exists';

// Button texts
export const CANCEL_TITLE = 'Cancel';

export const SAVE_TITLE = 'Save & Close';

export const DATE_OPTIONS_REPORT_BUILDER = [
    {name: 'Yesterday', value: 'YESTERDAY'},
    {name: 'Last 7 Days', value: 'LAST_SEVEN_DAYS'},
    {name: 'Last 30 Days', value: 'LAST_THIRTY_DAYS'},
    {name: 'Last week', value: 'LAST_WEEK'},
    {name: 'Last month', value: 'LAST_MONTH'},
    {name: 'Custom', value: 'CUSTOM'},
];

// metrics
export const TOTAL_METRICS_OPTIONS = [
    {value: NET_REVENUE, text: 'Revenue',type: MONETIZATION_METRICS, isInternal: false},
    {value: AVG_RPM, text: 'Avg RPM', type: MONETIZATION_METRICS, isInternal: false},
    {value: PAGE_VIEWS, text: 'Monetizable Page Views', type: MONETIZATION_METRICS, isInternal: false},
    {value: VIEWABILITY, text: 'Avg Ad Viewabilty',type: MONETIZATION_METRICS, isInternal: false},
    {value: GROSS_REVENUE, text: 'Gross revenue',type: MONETIZATION_METRICS, isInternal: true},
    {value: AD_REQUEST, text: 'Total Ad Requests' , type: PERFORMANCE_METRICS, isInternal: false},
    {value: TOTAL_IMPRESSIONS, text: 'Impressions' , type: PERFORMANCE_METRICS, isInternal: false},
    {value: AVG_CPM, text: 'Avg CPM',type: PERFORMANCE_METRICS, isInternal: false},
    {value: INITIAL_IMPRESSIONS, text: 'Initial loads',type: PERFORMANCE_METRICS, isInternal: true},
    {value: REFRESH_IMPRESSIONS, text: 'Refresh',type: PERFORMANCE_METRICS, isInternal: true},
    {value: WINNING_BID, text: 'Winning Bids', type: PREBID_MONETIZATION_METRICS, isInternal: false},
    {value: BID_RATE, text: 'Bid Rate',type: PREBID_MONETIZATION_METRICS, isInternal: false},
    {value: WIN_RATE, text: 'Win Rate',type: PREBID_MONETIZATION_METRICS, isInternal: false},
    {value: GROSS_REVENUE_WITHOUT_DISCREPANCY, text: 'Gross Revenue w/o Discrepancy',type: PREBID_MONETIZATION_METRICS, isInternal: true},
    {value: BID_REQUEST, text: 'Bid Request',type: PREBID_MONETIZATION_METRICS, isInternal: true},
    {value: BID_RESPONSE, text: 'Bid Response',type: PREBID_MONETIZATION_METRICS, isInternal: true},
    {value: VIDEO_VIEWED, text: 'Video Viewed',type: PREBID_VIDEO_METRICS, isInternal: true},
    {value: VIDEO_START, text: 'Video Start',type: PREBID_VIDEO_METRICS, isInternal: true},
    {value: VIDEO_Q1, text: 'Video 25% Complete',type: PREBID_VIDEO_METRICS, isInternal: true},
    {value: VIDEO_Q2, text: 'Video 50% Complete',type: PREBID_VIDEO_METRICS, isInternal: true},
    {value: VIDEO_Q3, text: 'Video 75% Complete',type: PREBID_VIDEO_METRICS, isInternal: true},
    {value: VIDEO_COMPLETE, text: 'Video Complete',type: PREBID_VIDEO_METRICS, isInternal: true},
    {value: VIDEO_CLICK, text: 'Video Click',type: PREBID_VIDEO_METRICS, isInternal: true}
]
